/**
 * True when the org (or user/org auth id) is listed on a LaunchDarkly org-list flag.
 * Matches `shouldRenderMenuItem`: the flag may be a string or an array of ids.
 */
export function orgIsInLaunchDarkly(
  flagValue: unknown,
  orgId?: string | null,
  authId?: string | null,
): boolean {
  if (!flagValue) return false;
  const listed = Array.isArray(flagValue) ? flagValue : [flagValue as string];
  return listed.includes(orgId) || (!!authId && listed.includes(authId));
}
